class ApiProtocolError extends Error {
  /** Machine-readable backend error code (see BackendCodesEnum) */
  code: number;
  /** Optional extra payload the backend attached to the error (shape varies per endpoint) */
  details: any;

  constructor({ code, message, details }: {
    /** Machine-readable backend error code (see BackendCodesEnum) */
    code: number;
    /** Human-readable error message from the backend */
    message: string;
    /** Optional extra payload the backend attached to the error */
    details?: any;
  }) {
    super(message);
    this.name = 'ApiProtocolError';
    this.code = code;
    this.details = details;
  }
}

export default ApiProtocolError;
